import 'angular';

export function AshdownEventsService (
  $timeout,
  $translate,
  $window,
  API,
  confirm,
  sessionObjAPI
) {
  var AshdownEvents = function (event, vehicle) {
    this.origin     = sessionObjAPI.base().origin;
    this.Event      = event;
    this.vehicle    = vehicle || {};
  };

  AshdownEvents.prototype.addItems = function() {
    const self     = this;

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.BOOKING_MUST_FIRST_BE_SAVED', { name:'Ashdown Ingram' }), null, 'ashdownEventsAutoSave').then(function () {
      return self.Event.save();
    }).then(function (event) {
      $timeout(function () {
        $window.location.assign(`/ashdown.html?${self.buildQueryString()}`);
      });
    });
  };

  AshdownEvents.prototype.buildQueryString = function() {
    const self        = this;
    var queryString = {
      event_id: self.Event.event.id,
      hookUrl: self.hookUrl(),
      HOOKURL: `${API.url}/events/add_item_from_ashdown_ingram/${self.Event.event.id}`,
      type: 'inquiry'
    };

    if (self.vehicle.id) {
      let vehicle = angular.copy(self.vehicle);

      delete vehicle.follow_up_comment;

      queryString.vehicleInfo = angular.toJson(vehicle);

      queryString['NEW_ITEM-CUST_FIELD5[1]'] = self.vehicle.ashdown_ingram_vehicle_id;
      queryString['NEW_ITEM-CUST_FIELD6[1]'] = self.vehicle.make;
      queryString['NEW_ITEM-CUST_FIELD7[1]'] = self.vehicle.model;
    }

    return $.param(queryString);
  };

  AshdownEvents.prototype.hasSku = function(item) {
    var self = this;

    if (item) {
      return item.ashdown_ingram_sku;
    }

    var items = self.Event.event.invoice_items_attributes.filter(function (item) {
      return item.ashdown_ingram_sku;
    });

    return items.length;
  };

  AshdownEvents.prototype.hookUrl = function() {
    const self = this;

    return self.Event.event.vehicle_id ?
      `${self.origin}workshop.html#/${self.Event.event.customer_id}/${self.Event.event.vehicle_id}/event/${self.Event.event.id}`:
      `${self.origin}workshop.html#/${self.Event.event.customer_id}/event/${self.Event.event.id}`;
  };

  return AshdownEvents;
}
